export default function PIXMA_G2915() {

    return <>
        <p> <img src="https://image.kr.canon/re/product/2021110223104301_33143110.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2021110410320801_34075041.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2022041914201501_12385373.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/re/product/2022041914222801_12427415.jpg" width="98%" /> </p>
    </>
}